"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartWeb = void 0;
var React = __importStar(require("react"));
var createSvg_1 = require("../core/svg/createSvg");
var SVG = require('@svgdotjs/svg.js').SVG;
var ChartWeb = function (props) {
    var svgContainerRef = React.useRef(null);
    var svgRef = React.useRef(null);
    var _a = React.useState(props.config), config = _a[0], setConfig = _a[1];
    var _b = React.useState(), xyIndexes = _b[0], setXyIndexes = _b[1];
    var _c = React.useState(), popupInfo = _c[0], setPopupInfo = _c[1];
    var initSvg = function (svgElm, config) {
        if (svgElm)
            svgElm.innerHTML = '';
        var canvas = SVG();
        canvas.addTo(svgElm);
        var svg = createSvg_1.createSvg(canvas, config).svg;
        svgRef.current = svg;
    };
    React.useEffect(function () {
        initSvg(svgContainerRef.current, config);
        if (props.onRendered)
            props.onRendered(svgRef.current.getDataPointGroup(), svgRef.current.viewbox(), svgRef.current.chartXys);
    }, [config]);
    React.useEffect(function () {
        setConfig(JSON.parse(JSON.stringify(props.config)));
    }, [JSON.stringify(props.config)]);
    React.useEffect(function () {
        if (props.config)
            setConfig(props.config);
    }, []);
    React.useEffect(function () {
        if (props.onXyIndexesChanged && (xyIndexes === null || xyIndexes === void 0 ? void 0 : xyIndexes.length) && xyIndexes[0] && popupInfo) {
            var chartIdx = xyIndexes.findIndex(function (it) { return it.nearestY[1] === xyIndexes.reduce(function (acc, it) { return it.nearestY[1] < acc ? it.nearestY[1] : acc; }, 99999); });
            var xyIndex = xyIndexes[chartIdx];
            if (xyIndex) {
                props.onXyIndexesChanged(xyIndex, svgRef.current.viewbox(), popupInfo, chartIdx);
            }
        }
    }, [xyIndexes]);
    React.useEffect(function () {
        var _a;
        if (!props.cursorXy || !props.cursorXy[0] || !props.cursorXy[1])
            return;
        var xyIndexes = svgRef.current.getXYIndex(props.cursorXy[0], props.cursorXy[1]);
        var popupInfos = svgRef.current.getPopupInfo(xyIndexes[0].indexX);
        var singlePopupInfo = {
            title: ((_a = popupInfos.find(function (it) { return it.title; })) === null || _a === void 0 ? void 0 : _a.title) || "",
            rows: popupInfos.reduce(function (acc, it, i) { return acc.concat(it.rows); }, []),
        };
        setXyIndexes(xyIndexes);
        setPopupInfo(singlePopupInfo);
    }, ["" + (props.cursorXy ? props.cursorXy[0] : 0) + (props.cursorXy ? props.cursorXy[1] : 0)]);
    return (React.createElement("div", { style: { width: '100%' }, ref: svgContainerRef }));
};
exports.ChartWeb = ChartWeb;
